import { Category, Price } from 'shared-types/Common';
import { SpaCategoryItem } from 'voyager';
import { UNCATEGORIZED_VALUE } from './buildCategoryOptions';

function getMinPrice(items: { price?: Price | null }[] = []): Price | null {
  if (items.length === 0) return null;
  return items.reduce<Price | null>((min, item) => {
    if (!item.price) return min;
    if (!min || item.price.amount < min.amount) return item.price;
    return min;
  }, null);
}

export function mapCategoriesToCards(
  categories: Category[],
  entity: 'spaPackages' | 'treatments' | 'facilities',
  uncategorized?: { label: string; imageUrl?: string }
): SpaCategoryItem[] {
  const cards: SpaCategoryItem[] = categories.map((cat) => {
    const children = (cat[entity] ?? []) as { price?: Price | null }[];
    const minPrice = getMinPrice(children);

    return {
      id: String(cat.id),
      name: cat.name,
      imageUrl: cat.image?.url ?? undefined,
      price: minPrice ? { amount: minPrice.amount, currencyCode: minPrice.currencyCode } : null,
    };
  });

  if (uncategorized) {
    cards.push({
      id: UNCATEGORIZED_VALUE,
      name: uncategorized.label,
      imageUrl: uncategorized.imageUrl,
      price: null,
    });
  }

  return cards;
}
